import { styled } from '@mui/material'
import { CustomDialogComponent } from 'hello-design-system'

const VideoBackgroundDialogComponent = styled(CustomDialogComponent)(({ theme }) => (
    {
        '& .MuiDialog-paper': {
            backgroundColor: `${theme.palette.background?.default}E5 !important`
        },
        '.MuiButton-containedPrimary': {
            fontSize: '15px !important'
        },
        '.MuiButton-outlinedPrimary': {
            fontSize: '15px !important',
            '&:first-of-type': {
                marginRight: 'auto'
            }
        }
    }
))

export { VideoBackgroundDialogComponent }
